// extracted by mini-css-extract-plugin
export var comment = "styles-module--comment--615b0";
export var count = "styles-module--count--2a0f5";
export var dashed = "styles-module--dashed--833ba";
export var experts = "styles-module--experts--35052";
export var info = "styles-module--info--503e6";
export var main__rating = "styles-module--main__rating--765aa";
export var main__rating__title = "styles-module--main__rating__title--b8791";
export var overall__rating = "styles-module--overall__rating--e8512";
export var overall__rating__item = "styles-module--overall__rating__item--29316";
export var price = "styles-module--price--806f4";
export var price__value = "styles-module--price__value--00f02";
export var progress = "styles-module--progress--4ad87";
export var rating = "styles-module--rating--dd2ba";
export var stars = "styles-module--stars--e39d0";
export var tooltip = "styles-module--tooltip--4ac34";
export var tooltip__table = "styles-module--tooltip__table--0794c";
export var top = "styles-module--top--42a9a";